import React, { useState } from "react";
import WeddingInvitationEnding from "./WeddingInvitationEnding";
import envelopeBack from "../../assets/img/invitation-envelope-back.png";
import envelopeFront from "../../assets/img/invitation-envelope-front.png";
import card from "../../assets/img/invitation-ornate-card.png";
import callaLeft from "../../assets/img/invitation-calla-left.png";
import callaRight from "../../assets/img/invitation-calla-right.png";
import ribbon from "../../assets/img/invitation-ribbon.png";
import locket from "../../assets/img/invitation-locket.png";
import envelopePhoto from "../../assets/img/wedding-hero.jpg";
import monogram from "../../assets/img/wedding-monogram-white.png";
import cherryBlossomPhoto from "../../assets/img/chapters/chapter-photo-02.jpg";
import libraryPhoto from "../../assets/img/chapters/chapter-photo-03.jpg";
import { weddingContent } from "../../components/Wedding/content";
import "./WeddingInvitationCollage.css";
import { useInvitationLanguage } from "./InvitationLanguage";

export default function WeddingInvitationCollage() {
  const { language, t } = useInvitationLanguage();
  const [showMusic, setShowMusic] = useState(false);

  return (
    <section id="invitation-collage" className={`invitation-collage${showMusic ? " invitation-collage--music-open" : ""}`} aria-labelledby="invitation-card-title">
      <div className="invitation-collage__scene">
        <div className="invitation-collage__envelope">
          <img className="invitation-collage__envelope-back" src={envelopeBack} alt="" loading="lazy" />
          <img className="invitation-collage__portrait" src={envelopePhoto} alt={t("Black and white portrait of Hương and Lượng", "Ảnh chân dung đen trắng của Hương và Lượng")} loading="lazy" />
          <img className="invitation-collage__monogram" src={monogram} alt="" aria-hidden="true" />
          <img className="invitation-collage__envelope-front" src={envelopeFront} alt="" loading="lazy" />
        </div>

        <img className="invitation-collage__flower invitation-collage__flower--left" src={callaLeft} alt="" loading="lazy" />
        <img className="invitation-collage__flower invitation-collage__flower--right" src={callaRight} alt="" loading="lazy" />
        <img className="invitation-collage__ribbon" src={ribbon} alt="" loading="lazy" />

        <div className="invitation-collage__locket" aria-hidden="true">
          <svg viewBox="0 0 783 800" focusable="false">
            <defs>
              <clipPath id="invitation-heart-left">
                <path d="M466 723 C360 755 197 790 217 673 C219 635 249 610 283 609 C255 527 316 503 355 526 C419 556 461 636 466 723Z" />
              </clipPath>
              <clipPath id="invitation-heart-right">
                <path d="M658 614 C575 583 463 507 479 434 C491 376 550 370 615 412 C659 358 720 373 736 413 C761 478 705 577 658 614Z" />
              </clipPath>
            </defs>
            <image href={locket} width="783" height="800" />
            <image href={cherryBlossomPhoto} x="206" y="510" width="269" height="255" preserveAspectRatio="xMidYMid slice" clipPath="url(#invitation-heart-left)" />
            <image href={libraryPhoto} x="474" y="373" width="273" height="253" preserveAspectRatio="xMidYMid slice" clipPath="url(#invitation-heart-right)" />
          </svg>
        </div>

        <div className="invitation-collage__music">
          <button type="button" className="invitation-collage__record" aria-label={showMusic ? t("Close music player", "Đóng trình phát nhạc") : t("Play wedding music", "Phát nhạc cưới")} aria-expanded={showMusic} aria-controls="invitation-music" onClick={() => setShowMusic((current) => !current)}>
            <span className="invitation-collage__record-label" aria-hidden="true">
              <img className="invitation-collage__record-logo" src={monogram} alt="" />
            </span>
            <span className="invitation-collage__play" aria-hidden="true">{showMusic ? "×" : "▶"}</span>
          </button>
          <span className="invitation-collage__music-caption">{showMusic ? t("TAP TO CLOSE", "CHẠM ĐỂ ĐÓNG") : t("TAP TO PLAY", "CHẠM ĐỂ PHÁT")}</span>
        </div>

        <article className="invitation-collage__card">
          <img src={card} alt="" loading="lazy" />
          <div className="invitation-collage__card-content">
            <p className="invitation-collage__eyebrow">{t("JOIN US FOR", "Trân trọng kính mời")}<br />{t("THE WEDDING OF", "Quý khách đến chung vui cùng")}</p>
            <h2 id="invitation-card-title"><span>Hương</span><span>&amp; Lượng</span></h2>
            <p className="invitation-collage__date"><time dateTime="2027-01-17">{t("17 JANUARY 2027", "17/01/2027")}</time></p>
            <a className="invitation-collage__venue" href={weddingContent[language].details.directionsUrl} target="_blank" rel="noreferrer">WHITE PALACE VÕ VĂN KIỆT</a>
          </div>
        </article>
      </div>

      {showMusic && (
        <div id="invitation-music" className="invitation-collage__music-panel">
          <iframe title="Calum Scott - You Are The Reason" src="https://www.youtube.com/embed/ShZ978fBl6Y?autoplay=1&playsinline=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
        </div>
      )}
      <WeddingInvitationEnding />
    </section>
  );
}
